import React, { Component } from "react";
import ProcessScreen from "./newscreen";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import moment from "moment";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

const serverOptions = [
  {
    name: "localhost",
    value: "http://localhost:8000",
  },
  // {
  //   name: "New Development Cloud Server",
  //   value: "https://devnewonboarding.delpheon.io/v2simulator",
  // },
// {name:"QAnewCloudServer",value:"https://qanewonboarding.delpheon.io/v2simulator",},
//   {
//     name: "Prefab Cloud Server",
//     value: "https://prefabdevonboarding.delpheon.io/v2simulator",
//   }, 
//   {
//     name: "QA Cloud Server",
//     value: "https://testplatformcomponent.delpheon.io/v2simulator",
//   },
  // {
  //   name: "Development Cloud Server",
  //   value: "https://devplatformcomponentv1.delpheon.io/v2simulator",
  // },
//   {
//     name: "Demo Cloud Server",
//     value: "https://onboarding-demo.delpheon.io/v2simulator",
//   },
//   {
//     name: "On-Prem Server",
//     value: "http://onpremonboarding.avtserver.local/v2simulator",
//   },
//  {
//     name: "Sandbox Server 1",
//     value: "https://sandboxonboarding.delpheon.io/v2simulator",
//   },
//   {
//     name: "Sandbox Server 2",
//     value: "https://sandbox2onboarding.delpheon.io/v2simulator",
//   },
//   {
//     name: "Sandbox Server 3",
//     value: "https://sandbox3onboarding.delpheon.io/v2simulator",
//   },
//   {
//     name: "Sandbox Server 4",
//     value: "https://sandbox4onboarding.delpheon.io/v2simulator",
//   },
//   {
//     name: "Sandbox Server 5",
//     value: "https://sandbox5onboarding.delpheon.io/v2simulator",
//   },
//   {
//     name: "Sandbox Server 6",
//     value: "https://sandbox6onboarding.delpheon.io/v2simulator",
//   },
];

class FileUploadPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: "",
      isFilePicked: false,
      // filesCount: "",
      // rowCount: "",
      // data1: [],
      uploadlog: [],
      joblog: [],
      startid: "",
      stopid: "",
      configid: "",
      companyid: "",
      jobstatus: [],
      //url: "https://testplatformcomponent.delpheon.io/simulator",
      //url: "http://192.168.3.205:8000",
      url: "", //"http://localhost:8000",    //skmdeployement
      buttonstate: false,
      histbuttonstate: false,
      clearconfigstate: false,
      startlist: [],
      stoplist: [],
      joblist: [],
      currtitle: "Current Running Jobs",
      sdate: "",
      histDate: "",
      interval: "6",
      buttonlabel: "Start",
      logcount: 0,
      jobstatus1: [],
    };
    this.fetchJobStatus = this.fetchJobStatus.bind(this);
  }

  makeList = () => {
    fetch(this.state.url + "/listStatusfile")
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        if (data) {
          var arr1 = data;
          var arr2 = [];
          var arr3 = [];
          var arr4 = [];
          for (var i = 0; i < arr1.length; i++) {
            if (arr1[i].indexOf("start") != -1) {
              arr2.push(arr1[i].split(".")[0]);
            } else arr3.push(arr1[i].split(".")[0]);
            arr4.push(arr1[i].split(".")[0]);
          }
          this.setState(
            {
              joblist: arr4,
              startlist: arr2,
              stoplist: arr3,
            },
            () => this.handleConfigIdFromStart()
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  handleStartList = (event) => {
    this.setState(
      {
        stopid: event.target.id,
      },
      () => {
        this.handleStop();
      }
    );
  };
// ----------------------------------------------------------------------------
  handleStopList = (event) => {
    this.setState(
      {
        startid: event.target.id,
      },
      () => {
        this.handleStart();
      }
    );
  };

  changeHandler = (event) => {
    if (event.target.files[0]) {
      this.setState({
        selectedFile: event.target.files[0],
        isFilePicked: true,
      });
    } else if (!event.target.files[0]) {
      this.setState({
        isFilePicked: false,
        selectedFile: "",
      });
    }
  };

  fetchUploadLog = () => {
    fetch(this.state.url + "/getFileUploadlogfile")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          uploadlog: data,
        });
      });
  };

  fetchJobLog = () => {
    fetch(this.state.url + "/getDiscoverylogfile")
      // fetch("status.json")
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          joblog: data,
        });
      });
  };

  fetchJobStatus = () => {
    fetch(this.state.url + "/getJobStaus")
      // .then((response) => response.json())
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        if (data) {
          console.log(data);
          var arr2 = Object.keys(data);
          var arr3 = [];
          var arr4 = [];
          for (var i = 0; i < arr2.length; i++) {
            if (data[arr2[i]] == true) {
              arr3.push(arr2[i]);
            } else arr4.push(arr2[i]);
          }
          this.setState({
            jobstatus: arr3,
            currtitle: "Current Running Jobs",
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  handleGetConfig = () => {
    if (this.state.companyid != "") {
      // fetch(this.state.url + "/getConfigExcelFile/" + this.state.companyid, {    // comment skmdeploy
      fetch(this.state.url + "/getConfigFile" , {  
        method: "POST",
        headers: {"Content-Type": "application/pdf", },
        body: JSON.stringify({ company: this.state.companyid, type: "Z",}), // skmdeploy  C for config excel alone , anithe lese (z) for zip file
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `ConfigFile-` + this.state.companyid + '.zip' //`.xlsx`   //zip
          );

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        });

      // fetch(this.state.url + "/getConfigExcelFile/" + this.state.companyid, {
      //   method: "GET",
      //   headers: {
      //     "Content-Type": "application/pdf",
      //   },
      // })
      //   .then((response) => response.text())
      //   .then((data) => {
      //     console.log("Success:", data);
      //   });
    } else alert("Select Company");
  };
// ----------------------------------start get history config file------------------------------------------
  handleGetHistConfig = () => {
    if (
      this.state.histDate !== "" &&
      this.state.histDate !== "Invalid date" &&
      this.state.interval !== "" &&
      this.state.companyid !== ""
    ) {
      this.setState({ histbuttonstate: true });
      if (window.confirm("Are you sure you want to generate History Data?")) {
        fetch(this.state.url + "/clearconfig", {
          method: "POST",
          body: JSON.stringify({
            company: this.state.companyid,
            mode: "H",
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            // alert(data);

            fetch(this.state.url + "/genHistData", {
              method: "POST",
              headers: {
                "Content-Type": "application/pdf",
              },
              body: JSON.stringify({
                company: this.state.companyid,
                start: this.state.histDate,
                intervalHrs: this.state.interval,
              }),
            })
              .then((response) => response.blob())
              .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  `HistConfigFile-` + this.state.companyid + `.xlsx`
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
                this.setState({ histbuttonstate: false });
              });
          });
      } else {
        this.setState({ histbuttonstate: false });
        // Do nothing!
      }
    } else alert("Select Company,Date and Interval");
  };
  //added skm start
  // -----------------------------End Get history config file -----------------------------------------------
  handleGetConfigJson = () => {
    if (this.state.companyid != "") {
      fetch(this.state.url + "/getJsonDiscovery/" + this.state.companyid, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `ParamDetails-` + this.state.companyid + ".json" //`.xlsx`
          );

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        });
    } else alert("Select Company");
  };

  //added skm ends

  handleList = () => {
    fetch(this.state.url + "/listStatusfile")
      .then((response) => response.json())
      .then((data) => {
        // alert(data);
        this.setState({
          jobstatus: data,
          currtitle: "All files",
        });
      });
  };

  handleTelemetry = () => {
    fetch(this.state.url + "/telemetrystart")
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
      });
  };

  handleStart = () => {
    if (this.state.configid) {
      let operation;
      if (this.state.buttonlabel == "Start") {
        operation = "start";
      } else operation = "stop";
      if (
        window.confirm(
          "Are you sure you want to " + this.state.buttonlabel + " the Job?"
        )
      ) {
        fetch(this.state.url + "/StartStopTelGen", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            company: this.state.startid,
            mode: operation,
            //"start",
          }),
        })
          .then((response) => response.text())
          .then((data) => {
            alert(data);
            this.handleList();
            // this.fetchJobStatus();
            this.makeList();
          });
      } else {
        //do nothing
      }
    } else {
      alert("Select Company");
    }
  };
//Start Added for purge company skm
handleDelComp = () => {
  if (this.state.configid) {
    let operation;
    // if (this.state.buttonlabel == "Start") {
    //   operation = "start";
    // } else operation = "stop";
    if (
      window.confirm(
        "Are you sure you want to Delete the Company (No recovery, please take backup if required)"
      )
    ) {
      fetch(this.state.url + "/purgeCompany", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company: this.state.startid,  
        }),
      })
        .then((response) => response.text())
        .then((data) => {
          alert(data);
          this.setState({configid:""})
          this.handleList();
          // this.fetchJobStatus();
          this.makeList();
        });
    } else {
      //do nothing
    }
  } else {
    alert("Select Company");
  }
};
//End Added for purge Company skm
  handleStop = () => {
    if (window.confirm("Are you sure you want to stop the Job?")) {
      fetch(this.state.url + "/StartStopTelGen", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company: this.state.stopid,
          mode: "stop",
        }),
      })
        .then((response) => response.text())
        .then((data) => {
          alert(data);
          this.handleList();
          this.makeList();
        });
    } else {
      //do nothing
    }
  };

  handleConfigClear = () => {
    // this.fetchJobStatus().then(() => {
    fetch(this.state.url + "/getJobStaus")
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        var arr2 = Object.keys(data);
        var arr3 = [];
        var arr4 = [];
        for (var i = 0; i < arr2.length; i++) {
          if (data[arr2[i]] == true) {
            arr3.push(arr2[i]);
          } else arr4.push(arr2[i]);
        }
        this.setState({
          jobstatus: arr3,
          currtitle: "Current Running Jobs",
        });

        if (this.state.configid) {
          if (this.state.jobstatus.includes(this.state.configid)) {
            alert(
              "Please wait for company process to end, which  may take time(around Interval) specified in uploaded template for the selected company"
            );
          } else if (
            window.confirm("Are you sure you want to clear the config?")
          ) {
            fetch(this.state.url + "/clearconfig", {
              method: "POST",
              body: JSON.stringify({
                company: this.state.configid,
                mode: "N",
              }),
            })
              .then((response) => response.text())
              .then((data) => {
                alert(data);
              });
          } else {
            // Do nothing!
          }
        } else {
          alert("Select Company");
        }
      });
  };

  /* skm old clear skmold clear skmdepl*/
  handleClear = () => {
    if (this.state.url != "") {
      if (window.confirm("Are you sure you want to clear the log file?")) {
        fetch(this.state.url + "/clearlog")
          .then((response) => response.text())
          .then((data) => {
            alert(data);
            this.setState({
              joblog: [],
              uploadlog: [],
            });
          });
      } else {
        // Do nothing!
      }

      // fetch(this.state.url + "/clearlog")
      //   .then((response) => response.text())
      //   .then((data) => {
      //     alert(data);
      //   });
    }
  };

  handleUrl = (event) => {
    this.fileInput.value = "";
    this.setState(
      {
        url: event.target.value,
        jobstatus: [],
        uploadlog: [],
        joblog: [],
        startlist: [],
        stoplist: [],
        joblist: [],
        companyid: "",
        configid: "",
        isFilePicked: false,
        selectedFile: null,
      },
      () => {
        this.fetchJobStatus();
        this.makeList();
      }
    );
  };

  handleConfigId = (event) => {
    let startlist = this.state.startlist;
    let stoplist = this.state.stoplist;
    let label = "";
    let config_button_state;

    if (startlist.includes(event.value)) {
      label = "Stop";
      config_button_state = true;
      console.log("Start");
    } else {
      console.log("Stop");
      label = "Start";
      config_button_state = false;
    }
    this.setState({
      configid: event.value,
      startid: event.value,
      stopid: event.value,
      buttonlabel: label,
      clearconfigstate: config_button_state,
    });
  };

  handleConfigIdFromStart = () => {
    let startlist = this.state.startlist;
    let stoplist = this.state.stoplist;
    let label = "";
    let config_button_state;
    if (this.state.configid) {
      if (startlist.includes(this.state.configid)) {
        label = "Stop";
        config_button_state = true;
        console.log("Start");
      } else {
        console.log("Stop");
        label = "Start";
        config_button_state = false;
      }
      this.setState({
        buttonlabel: label,
        clearconfigstate: config_button_state,
      });
    } else {
    }
  };

  handleCompanyId = (event) => {
    this.setState({
      companyid: event.value,
    });
  };

  handleInterval = (event) => {
    console.log(event.target);
    this.setState({
      interval: event.target.value,
    });
  };

  handleSubmission = () => {
    if (this.state.url != "") {
      // console.log(selectedjobid);
      fetch(this.state.url + "/getJobStaus")
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          var arr2 = Object.keys(data);
          var arr3 = [];
          for (var i = 0; i < arr2.length; i++) {
            if (data[arr2[i]] == true) {
              arr3.push(arr2[i]);
            }
          }
          this.setState({
            jobstatus: arr3,
            currtitle: "Current Running Jobs",
          });

          if (this.state.selectedFile) {
            let selectedjobid = this.state.selectedFile.name.split(".")[0];
            if (this.state.startlist.includes(selectedjobid)) {
              alert(
                "Please initiate process stop for the selected company .. post that need to wait for actual process to end, which  may take time(around Interval) specified in uploaded template for the selected company "
              );
            } else if (this.state.jobstatus.includes(selectedjobid)) {
              alert(
                "Please wait for company process to end, which  may take time(around Interval) specified in uploaded template for the selected company"
              );
            } else {
              this.setState({ buttonstate: true });
              const formData = new FormData();

              formData.append("file", this.state.selectedFile);

              fetch(this.state.url + "/uploadConfigfile", {
                method: "POST",
                body: formData,
              })
                .then((response) => response.text())
                .then((data) => {
                  alert(data);
                  if (data == "File upload Success") {
                    this.fileInput.value = "";
                    this.setState(
                      {
                        buttonstate: false,
                        isFilePicked: false,
                        selectedFile: "",
                      },
                      () => {
                        this.makeList();
                      }
                    );
                  } else {
                    this.fileInput.value = "";
                    this.setState(
                      {
                        buttonstate: false,
                        isFilePicked: false,
                        selectedFile: "",
                        companyid: "",
                        configid: "",
                      },
                      () => {
                        this.fetchUploadLog();
                        this.makeList();
                      }
                    );
                  }
                })
                .catch((error) => {
                  alert("No reponse, Please Try Again");
                  this.fileInput.value = "";
                  this.setState(
                    {
                      buttonstate: false,
                      isFilePicked: false,
                      selectedFile: "",
                    },
                    () => {
                      this.fetchUploadLog();
                    }
                  );
                });
            }
          } else {
            alert("Please Select File");
          }
        });
    }
  };

  handleStartDate = (event) => {
    console.log(moment(event).format("DD-MM-YYYY"));
    this.setState({
      sdate: event,
      histDate: moment(event).format("DD-MM-YYYY"),
    });
  };

  startTelemetry = () => {
    var controller = new AbortController();
    var signal = controller.signal;
    setTimeout(function () {
      controller.abort();
      alert("Started");
    }, 5000);
    fetch(this.state.url + "/telemetrystart", { signal })
      // .then((response) => response.json())
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
      })
      .then((data) => {
        alert(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /*start Get Log files */
  handleGetLog = () => {
    if (this.state.url != "") {
      fetch(this.state.url + "/getfile/EM", {
        method: "GET",
        headers: {
          "Content-Type": "application/txt",
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `LogFile` + ".txt" //`.xlsx`
          );

          // Append to html link element page
          document.body.appendChild(link);

          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        });
    } else alert("Select Server");
  };
  /*end  Get Log Files */

    /* Start #chgRDPMSParamLogic function */
    handlePrepareFile = () => {
      // window.open("http://localhost:8501", "_blank"); // Opens in a new tab
      window.open("https://qanewonboarding.delpheon.io/prepare-configfile/", "_blank"); // Opens in a new tab
      
    };

    /* end  #chgRDPMSParamLogic function*/

  /**clear log start skmclr*/
  // clearLog = () =>
  // {
  // if (window.confirm("Are you sure you want to clear log?"))
  //   {
  //     {
  //       fetch(this.state.url + "/clearlog")
  //       // {this.fetchJobLog}
  //     }
  //   }
  // }
  /* clear log end */

  //---------------------------------   Component Mount start  -------------------------------------------
  componentDidMount() {
    this.makeList();
    this.fetchJobStatus();
    this.fetchJobLog();
    this.fetchUploadLog();
  }
  //---------------------------------   Component Mount End  -------------------------------------------

  //--------------------------------------------------------------------------------------------
  //---------------------------------   Render Part  -------------------------------------------
  //--------------------------------------------------------------------------------------------
  render() {
    return (
      <div style={{ fontFamily: "Roboto, Sans-Serif" }}>
        <div
          style={{
            backgroundImage: `linear-gradient(
              90deg
              ,rgb(103 128 199),rgb(247 183 133))`,
          }}
        >
          <div style={{ paddingTop: "10px" }}>
            {/* <input
              type="text"
              value={this.state.url}
              onChange={this.handleUrl}
              style={{ width: "300px", height: "25px", marginLeft: "622px" }}
            /> */}
            {
              <select
                id="idurl"
                value={this.state.url || ""}
                style={{
                  marginLeft: "50px",
                  width: "320px",
                  height: "30px",
                }}
                //skmdeployement
                onChange={this.handleUrl}
              >
                <option value={""}> Select Server </option>
                {/* <option value={"http://192.168.3.205:8000"} > Server URL </option>    */}
                {/* <option value={"http://localhost:8000"} > localhost </option>               */}
                {[...(Window.__ServerOptions || serverOptions)]?.map(
                  (option, index) => (
                    <option value={option.value}> {option.name} </option>
                  )
                )}
              </select>
            }

            {/* start added as part for #chgRDPMSParamLogic */}
            <button
              style={{
                marginLeft: "50px",
                width: "120px",
                height: "30px",
              }}
              onClick={this.handlePrepareFile}
            >
              Prepare File
            </button>
            {/* end added as part for #chgRDPMSParamLogic */}

            <button
              style={{
                marginLeft: "10px",  
                width: "120px",
                height: "30px",
              }}
              onClick={this.startTelemetry}
            >
              Start Telemetry
            </button>

            <button
              style={{
                marginLeft: "10px",
                width: "120px",
                height: "30px",
              }}
              onClick={this.fetchJobStatus}
            >
              JOB Status
            </button>
            <button
              style={{
                marginLeft: "10px",
                width: "120px",
                height: "30px",
                marginBottom: "10px",
              }}
              onClick={this.fetchJobLog}
            >
              Get Error Log
            </button>

            {/* start get log */}
            <button
              style={{
                marginLeft: "10px",
                width: "120px",
                // marginTop: "30px",
                height: "30px",
              }}
              // onClick={this.handleGetConfig}
              onClick={this.handleGetLog}
            >
              {" "}
              Get Log Files{" "}
            </button>
            {/* End get log */}
            {/* strt clear log skmclr skmdepl*/}
            <button
              style={{
                marginLeft: "10px",
                width: "120px",
                height: "30px",
              }}
              /*onClick={this.clearLog}*/
              onClick={this.handleClear}
            >
              Clear Log
            </button>
            {/*end clear log */}
          </div>
        </div>
        <div className="grid1">
          <div
            className="box5"
            style={{ height: "230px", textAlign: "center" }}
          >
            <h3
              style={{
                margin: "0",
                textAlign: "center",
                // marginLeft: "20px",
                fontSize: "18px",
                color: "#4971b9",
                marginBottom: "20px",
                // backgroundColor: "#fcdc4b",
              }}
            >
              File Upload
            </h3>
            <input
              type="file"
              name="file"
              onChange={this.changeHandler}
              ref={(ref) => (this.fileInput = ref)}
            />
            <div style={{ height: "110px" }}>
              {this.state.isFilePicked ? (
                <div style={{ fontSize: "13px" }}>
                  <p>Filename: {this.state.selectedFile.name}</p>
                  <p>Filetype: {this.state.selectedFile.type}</p>
                  <p>Size in bytes: {this.state.selectedFile.size}</p>
                  <p>
                    lastModifiedDate:{" "}
                    {this.state.selectedFile.lastModifiedDate.toLocaleDateString()}
                  </p>
                </div>
              ) : (
                <div>
                  <p>Select a file to show details</p>
                </div>
              )}
            </div>
            <br />
            <div>
              <button
                disabled={this.state.buttonstate}
                onClick={this.handleSubmission}
              >
                Submit
              </button>
            </div>
          </div>
          <div>
            <div
              className="box5"
              style={{
                height: "230px",
                fontSize: "16px",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: "0",
                    textAlign: "center",
                    // marginLeft: "20px",
                    fontSize: "18px",
                    color: "#4971b9",
                    marginBottom: "20px",
                    // backgroundColor: "#fcdc4b",
                  }}
                >
                  Job Operations
                </h3>
                <div className="companygrid" style={{ padding: "5px" }}>
                  <div>
                    <label>Select Company</label>
                  </div>{" "}
                  <Dropdown
                    options={this.state.joblist}
                    value={this.state.configid}
                    onChange={this.handleConfigId}
                    className="dropdownClass"
                    placeholder="Select Company"
                  />
                </div>
                <button
                  style={{ marginLeft: "10px", marginTop: "130px" }}
                  onClick={this.handleStart}
                >
                  {" "}
                  {this.state.buttonlabel}
                </button>
                <button
                  style={{ marginLeft: "10px", marginTop: "10px" }}
                  onClick={this.handleConfigClear}
                  disabled={this.state.clearconfigstate}
                >
                  {" "}
                  Clear Config{" "}
                </button>
                {/*!-- Skmpurge code end   -->*/}
                <button
                  style={{ marginLeft: "10px", marginTop: "10px" }}
                  onClick={this.handleDelComp}
                  // disabled={this.state.clearconfigstate}
                >                  
                  Purge Company
                </button>
                {/*!-- Skm code end   -->*/}
              </div>
            </div>
          </div>
          <div
            className="box5"
            style={{
              height: "230px",
              textAlign: "left",
            }}
          >
            <h3
              style={{
                margin: "0",
                textAlign: "center",
                // marginLeft: "20px",
                // paddingLeft: "20px",
                fontSize: "18px",
                color: "#4971b9",
                // backgroundColor: "#fcdc4b",
              }}
            >
              File Status
            </h3>
            <div
              className="listgrid"
              // style={{ fontSize: "16px", height: "200px", overflowY: "auto" }}
              style={{
                // backgroundColor: "#F0F4F8", // Soft light blue-gray
                backgroundColor: "#EAE6F5", // Soft lavender with a calming vibe
                color: "#333", // Darker text for contrast
                fontSize: "16px",
                height: "200px",
                overflowY: "auto",
                padding: "10px",
                borderRadius: "8px" // Optional for softer edges
              }}
            >
              <div style={{ margin: "0", flex: 1 }}>
                &emsp;
                <div
                  style={{
                    color: "#4971b9",
                    margin: "0",
                    // marginLeft: "30px",
                    marginBottom: "10px",
                    // backgroundColor: "#fcdc4b",
                    textAlign: "center",
                  }}
                >
                  <b> Stopped</b>
                </div>
                {this.state.stoplist.map((k) => {
                  return (
                    <li
                      style={{
                        color: "#666666",
                        marginLeft: "10px",
                        lineBreak: "anywhere",
                        paddingBottom: "5px",
                        // fontFamily: "Courier New",
                      }}
                      id={k}
                    >
                      {k}
                    </li>
                  );
                })}
              </div>
              <div style={{ marginLeft: "5px", flex: 1 }}>
                &emsp;
                <div
                  style={{
                    color: "#4971b9",
                    // marginLeft: "5px",
                    textAlign: "center",
                    marginBottom: "10px",
                    // backgroundColor: "#fcdc4b",
                  }}
                >
                  <b> Started</b>
                </div>
                {this.state.startlist.map((k) => {
                  return (
                    <li
                      style={{
                        color: "#666666",
                        marginLeft: "10px",
                        lineBreak: "anywhere",
                        paddingBottom: "5px",
                        // fontFamily: "Courier New",
                      }}
                      id={k}
                    >
                      {k}
                    </li>
                  );
                })}
              </div>
            </div>
          </div>
          <div>
            <div
              className="box5"
              style={{
                height: "230px",
                textAlign: "left",
                wordBreak: "break-word",
              }}
            >
              <div
                style={{
                  // paddingLeft: "10px",
                  textAlign: "center",
                }}
              >
                <h3
                  style={{
                    margin: "0",
                    textAlign: "center",
                    // marginLeft: "10px",
                    color: "#4971b9",
                    fontSize: "18px",
                    marginBottom: "10px",
                    // backgroundColor: "#fcdc4b",
                  }}
                >
                  {this.state.currtitle}
                </h3>
                <div
                  style={{
                    overflowY: "auto",
                    height: "180px",
                    paddingLeft: "5px",
                  }}
                >
                  <ul>
                    {this.state.jobstatus.map((key, i) => {
                      return (
                        <li
                          style={{
                            color: "#666666",
                            textAlign: "left",
                            paddingBottom: "5px",
                            // fontFamily: "Courier New"
                          }}
                          key={i}
                        >
                          {key}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottomgrid">
          <div
            className="box5"
            style={{
              // overflow: "scroll",
              textAlign: "left",
              whiteSpace: "pre-line",
              // fontFamily: "Courier New",
              height: "250px",
            }}
          >
            <Tabs>
              <TabList>
                {/* <Tab>Validation Log</Tab>  #entire section can be removed later
                <Tab>Job Log</Tab> */}                
                <Tab>Error Log</Tab>                
              </TabList>

              <TabPanel>
                <div style={{ overflow: "scroll", height: "215px" }}>
                  <div className="loggrid">
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Timestamp
                    </h3>
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Type
                    </h3>
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Details
                    </h3>
                  </div>
                  {/* {this.state.uploadlog.map((k) => ( */}
                  {this.state.joblog.map((k) => (  
                    <div className="loggrid">
                      <div>{k.Timestamp}</div>
                      <div>{k.Type}</div>
                      <div>{k.Details}</div>
                    </div>
                  ))}{" "}
                </div>
              </TabPanel>
              <TabPanel>
                <div style={{ overflow: "scroll", height: "215px" }}>
                  <div className="loggrid">
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Timestamp
                    </h3>
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Type
                    </h3>
                    <h3
                      style={{
                        margin: "0",
                        fontSize: "18px",
                        color: "#4971b9",
                        marginBottom: "20px",
                      }}
                    >
                      Details
                    </h3>
                  </div>
                  {/* {this.state.joblog.map((k) => ( */}
                  {this.state.uploadlog.map((k) => (  
                    <div className="loggrid">
                      <div>{k.Timestamp}</div>
                      <div>{k.Type}</div>
                      <div>{k.Details}</div>
                    </div>
                  ))}{" "}
                </div>
              </TabPanel>
            </Tabs>
          </div>
          {/* //#--------------History data Box Start-------------- */}
          <div>
            {" "}
            {/* History box Main Div Start */}
            <div className="box5" style={{ height: "250px", fontSize: "15px" }}>
              <h3
                style={{
                  margin: "0",
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#4971b9",
                  marginBottom: "20px",
                  // backgroundColor: "#fcdc4b",
                }}
              >
                History Data
              </h3>
              <div
                className="companygrid"
                style={{ width: "320px", marginLeft: "20px" }}
              >
                <div>
                  <label> Company ID </label>
                </div>{" "}
                <Dropdown
                  options={this.state.joblist}
                  onChange={this.handleCompanyId}
                  className="dropdownClass"
                  placeholder="Select Company"
                  value={this.state.companyid}
                />
              </div>
              <div
                className="companygrid"
                style={{
                  marginTop: "10px",
                  width: "320px",
                  marginLeft: "20px",
                }}
              >
                <label>Date</label>
                <div>
                  <DatePicker
                    onChange={(date) => this.handleStartDate(date)}
                    className="startdate"
                    selected={this.state.sdate}
                    maxDate={new Date()}
                  />
                </div>
              </div>
              <div
                className="companygrid"
                style={{
                  marginTop: "10px",
                  width: "320px",
                  marginLeft: "20px",
                }}
              >
                <label>Interval(Hrs)</label>
                <input
                  type="text"
                  value={this.state.interval}
                  onChange={this.handleInterval}
                  style={{ width: "140px", height: "15px" }}
                />
              </div>

              {/* <button
                style={{
                  marginLeft: "5px",
                  width: "160px",
                  marginTop: "70px",
                }}
                onClick={this.handleGetHistConfig} //decommision #skmchgDec2022
                // onClick={this.handleGetConfigZip} //added #skmchgDec2022
                disabled={this.state.histbuttonstate}
              >
                {" "}
                Get History Config File{" "}
              </button> */}
              <button
                style={{
                  marginLeft: "20px",
                  width: "170px",
                  marginTop: "50px",
                }}
                onClick={this.handleGetConfig}
              >
                {" "}
                Get Config File{" "}
              </button>
              {/* //#--------------Get Param json button Start-------------- */}
              <button //added skm
                style={{
                  marginLeft: "5px",
                  // width: "350px",
                  width: "160px",
                  marginTop: "10px",
                }}
                onClick={this.handleGetConfigJson}
              >
                {" "}
                Get Param JSON{" "}
              </button>            

              {/* //#--------------Get Param json button End-------------- */}

               {/* //-------------Start Heartbeat file 20102023-------------- */}
 	            <button
                style={{
                  marginLeft: "20px",
                  width: "170px",
                  marginTop: "10px",
                }}
                onClick={this.handleGetHBTFile}
              >
                {" "}
                Get HeartBeat config File{" "}
              </button>

	      {/* //-------------End Heartbeat file 20102023-------------- */}  

            </div>{" "}
            {/* History box Sub Div End */}
          </div>{" "}
          {/* History box Main Div End */}
        </div>
      </div>
    );
  }
}
export default FileUploadPage;
